import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import { UserService } from 'app/core/user/user.service';
import { map, of, switchMap, take } from 'rxjs';

export const ManagerAdminGuard: CanActivateFn = (route, state) => {
    const router: Router = inject(Router);
    const authService: AuthService = inject(AuthService);
    const userService: UserService = inject(UserService);

    // Check the authentication status first
    return authService.check().pipe(
        switchMap((authenticated) => {
            // If the user is not authenticated, redirect to sign-in
            if (!authenticated) {
                const redirectURL = `redirectURL=${state.url}`;
                const urlTree = router.parseUrl(`sign-in?${redirectURL}`);
                return of(urlTree);
            }

            // If authenticated, check the user role
            return userService.adminUserInfo$.pipe(
                take(1),
                map((userInfo) => {
                    // Check if user has manager or admin role
                    if (
                        ['manager', 'admin', 'hr', 'finance'].includes(
                            userInfo?.role
                        )
                    ) {
                        return true;
                    }

                    // If user doesn't have the required role, redirect to the default page
                    console.warn('Access denied: User role is', userInfo?.role);
                    return router.parseUrl('/project-management');
                })
            );
        })
    );
};
